const rulesmarkdown = `
  ### Lorem ipsum dolor amet

  Quisque vulputate pharetra lorem in interdum. Cras bibendum magna aliquet mauris congue accumsan. 
  **Pellentesque sagittis** libero vel ante cursus aliquet. Suspendisse pharetra purus tortor, non pretium sem cursus eget.


  > This Markdown cheat sheet provides a quick overview of all the Markdown syntax elements.
  


  Proin rutrum lacus scelerisque sapien sollicitudin, volutpat pretium enim lacinia. Aliquam nisl nisl, porta ut turpis et, fringilla commodo mauris. 
  Nulla semper molestie rhoncus. Sed bibendum tortor risus, quis sollicitudin lectus aliquam. 
  Praesent sed eros ac magna sodales **volutpat non vel metus**.

  | Syntax | Description |
  | ----------- | ----------- |
  | Header | Title |
  | Paragraph | Text |


  It can’t cover every edge case, so if you need more information about any of these elements, 
  refer to the reference guides for **basic syntax and extended syntax**.
  Sed bibendum tortor risus, quis sollicitudin lectus aliquam. Ut in imperdiet massa. 
  Maecenas augue ipsum, pulvinar sit amet finibus in, ac nunc. Suspendisse elementum in [3i INC](https://3iinc.xyz). 

  ### Curabitur fringilla quis enim eget laoreet.
  Aliquam nisl nisl, porta ut turpis et, fringilla commodo mauris. 
  Nulla semper molestie rhoncus.
  

  - Markdown cheat sheet
  - [Basic syntax and Extended syntax](https://www.markdownguide.org/cheat-sheet/)
  - Sapien sollicitudin, volutpat pretium


  Mauris facilisis nisl blandit massa fermentum blandit in sed diam. Class aptent taciti sociosqu 
  ad litora torquent *per conubia nostra*, per inceptos himenaeos.

  ![Alt Img Text](https://images.ctfassets.net/2g0bd82kkvps/3RNU3Vs1HtHyzNweWwOo6e/d113bc191a6ae4eec677ebcb0f191186/Corona_Virus__And_Vaccant_Streets.jpg?w=920&q=70&fm=webp "Covid 19 Ghost")

  #### Aliquam placerat convallis lectus in pharetra
  
  Sed bibendum tortor risus, quis sollicitudin lectus aliquam et. 
  Praesent sed eros ac magna sodales volutpat non vel metus.


  1. Fringilla quis enim eget laoreet
  2. Sapien sollicitudin, volutpat pretium
  3. Blandit massa fermentum blandit in sed diam


  Integer ut erat vitae dolor pharetra [consectetur](https://www.ieeesctsb.org/) nec quis mi.
  ---
  `;

export default rulesmarkdown;
